import { getReferenceId } from '@quromedical/fhir-common';
import type { Note } from '@quromedical/models';
import { NoteCard } from 'core/notes';
import {
  Skeleton,
  SkeletonProvider,
  Spacer,
  Text,
  Visible,
} from 'design-system';
import { MARGIN } from 'design-system/theme';
import { useUserSession } from 'hooks/useUserSession';
import type React from 'react';
// all these components should be moved into core
import { downloadAttachment } from 'screens/patient';
import { strings } from 'strings';

interface NotesSectionProps {
  notes?: Note[];
  loading?: boolean;
}

const placeholder = '_____________________';

const Loading: React.FC = () => (
  <SkeletonProvider loading>
    {new Array(3).fill(0).map((_, i) => (
      <>
        <Spacer height={MARGIN.s} />
        <Skeleton>
          <NoteCard
            patientId=""
            key={i}
            onAttachmentPress={downloadAttachment}
            note={{
              id: '',
              media: [],
              note: {
                subjective: [placeholder],
                assessment: placeholder,
                objective: placeholder,
                plan: placeholder,
              },
              practitionersToNotify: [],
              vitals: {},
              pinned: false,
            }}
            canPin={false}
            canEdit={false}
            onTaskSubmit={undefined}
            addNote={undefined}
          />
        </Skeleton>
      </>
    ))}
  </SkeletonProvider>
);

export const NotesSection: React.FC<NotesSectionProps> = ({
  notes,
  loading = false,
}) => {
  const session = useUserSession();
  const profile = session.getProfile();

  if (loading) {
    return <Loading />;
  }

  if (!notes?.length) {
    return (
      <Text variant="page-heading">
        {strings.PatientPrintSummaryPlaceholderNoNotes}
      </Text>
    );
  }

  return (
    <>
      {notes?.map((note, index) => {
        const canEdit = getReferenceId(note.assessor) === profile?.id;
        const patientId = note.admission?.subject?.id as string;

        return (
          <>
            <Visible if={index}>
              <Spacer height={MARGIN.s} />
            </Visible>
            <NoteCard
              onAttachmentPress={downloadAttachment}
              note={note}
              canPin={false}
              canEdit={canEdit}
              patientId={patientId}
              onTaskSubmit={async () => {
                return;
              }}
              addNote={undefined}
            />
          </>
        );
      })}
    </>
  );
};
